export default __webpack_public_path__ + "static/media/539-Series-Electronic-switchover-IntelliSwitch.3d1b399b.jpg";